import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { minBreakpoints } from "../constants/breakpoints";
var sizes = {
  font32: {
    fontSize: 32,
    lineHeight: 48
  },
  font30: {
    fontSize: 30,
    lineHeight: 45
  },
  font28: {
    fontSize: 28,
    lineHeight: 42
  },
  font26: {
    fontSize: 26,
    lineHeight: 39
  },
  font24: {
    fontSize: 24,
    lineHeight: 36
  },
  font22: {
    fontSize: 22,
    lineHeight: 33
  },
  font20: {
    fontSize: 20,
    lineHeight: 30
  },
  font18: {
    fontSize: 18,
    lineHeight: 27
  },
  font16: {
    fontSize: 16,
    lineHeight: 24
  },
  font14: {
    fontSize: 14,
    lineHeight: 21
  },
  font12: {
    fontSize: 12,
    lineHeight: 18
  },
  font10: {
    fontSize: 10,
    lineHeight: 15
  }
};
export var responsiveHeadingXL = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";", ";"], pxToRem(sizes.font28.fontSize), pxToRem(sizes.font28.lineHeight), mediaQuery({
  min: minBreakpoints.M
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font30.fontSize), pxToRem(sizes.font30.lineHeight))), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font32.fontSize), pxToRem(sizes.font32.lineHeight))));
export var responsiveHeadingLG = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";", ";"], pxToRem(sizes.font24.fontSize), pxToRem(sizes.font24.lineHeight), mediaQuery({
  min: minBreakpoints.M
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font26.fontSize), pxToRem(sizes.font26.lineHeight))), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font28.fontSize), pxToRem(sizes.font28.lineHeight))));
export var responsiveHeadingMD = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";", ";"], pxToRem(sizes.font20.fontSize), pxToRem(sizes.font20.lineHeight), mediaQuery({
  min: minBreakpoints.M
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font22.fontSize), pxToRem(sizes.font22.lineHeight))), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font24.fontSize), pxToRem(sizes.font24.lineHeight))));
export var responsiveHeadingSM = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";"], pxToRem(sizes.font18.fontSize), pxToRem(sizes.font18.lineHeight), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font20.fontSize), pxToRem(sizes.font20.lineHeight))));
export var responsiveHeadingXS = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";"], pxToRem(sizes.font16.fontSize), pxToRem(sizes.font16.lineHeight), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font18.fontSize), pxToRem(sizes.font18.lineHeight))));
export var responsiveBodyMD = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";"], pxToRem(sizes.font14.fontSize), pxToRem(sizes.font14.lineHeight), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font16.fontSize), pxToRem(sizes.font16.lineHeight))));
export var responsiveBodySM = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";"], pxToRem(sizes.font12.fontSize), pxToRem(sizes.font12.lineHeight), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font14.fontSize), pxToRem(sizes.font14.lineHeight))));
export var responsiveBodyXS = /*#__PURE__*/css(["font-size:", ";line-height:", ";", ";"], pxToRem(sizes.font10.fontSize), pxToRem(sizes.font10.lineHeight), mediaQuery({
  min: minBreakpoints.L
}, css(["font-size:", ";line-height:", ";"], pxToRem(sizes.font12.fontSize), pxToRem(sizes.font12.lineHeight))));